import { createSelector } from "@ngrx/store";
import { staged, title } from '../reducers/slides.reducer';
import { ReportsState } from '../reducers';

const slidesState = (state: ReportsState) => state.slides
export const getStaged = createSelector(slidesState, staged);
export const getSlidesTitle = createSelector(slidesState, title);
